import { DayJsWrapper } from './dayjs-wrapper';

export class DateForPmis extends Date {
    static cnt = 0;

    private static __timeZoneId = '';
    private static get _timeZoneId(): string {
        return this.__timeZoneId;
    }
    static get timeZoneId(): string {
        return this.__timeZoneId;
    }

    static setTimeZoneId(value: string) {
        this.__timeZoneId = value;
        this._timeZoneLocal = undefined;
    }

    private static _timeZoneLocal: boolean | undefined;
    private static get timeZoneSameAsLocale(): boolean {
        const tzid = this._timeZoneId;
        if (!tzid) return true;

        if (this._timeZoneLocal === undefined) {
            const dt = new Date();
            this._timeZoneLocal =
                dt.toLocaleString('en') ===
                dt.toLocaleString('en', { timeZone: tzid });
            console.log('timeZoneLocal', this._timeZoneLocal, tzid);
        }
        return this._timeZoneLocal;
    }

    private _kind: DateTimeKind = 'Local';
    constructor(dt?: string | Date | number | DateForPmis) {
        super(dt || new Date());
        if (dt && dt instanceof DateForPmis) {
            this._kind = dt._kind;
        } else if (DateForPmis._timeZoneId) {
            this._kind = 'System';
        }

        if (!dt) {
            this.tryConvertToSystem();
        }

        DateForPmis.cnt++;
        if (DateForPmis.cnt % 500000 === 0)
            console.log('DateForPmis.cnt', DateForPmis.cnt);
    }

    private _getSystemZoneLocaleStr(dt: Date | undefined = undefined) {
        return (dt || this).toLocaleString('en', {
            timeZone: DateForPmis._timeZoneId,
        });
    }

    tryConvertToSystem() {
        if (DateForPmis._timeZoneId) {
            if (!isNaN(this.valueOf()) && !DateForPmis.timeZoneSameAsLocale) {
                const tm = DayJsWrapper.fromLocaleToTimeZone(
                    this,
                    DateForPmis._timeZoneId
                );
                this.setTime(tm.getTime());
            }
            this._kind = 'System';
        }
    }

    toLocal(): DateForPmis {
        if (this._kind === 'Local') return this;

        let dtr: Date | undefined;
        if (this._kind === 'System') dtr = this._convertSystemDtToLocal();
        else if (this._kind === 'UTC') dtr = this._convertUtcToLocal();

        if (dtr) this.setTime(dtr.getTime());
        this._kind = 'Local';
        return this;
    }

    private _convertSystemDtToLocal(): Date {
        const dt = new Date(this);
        if (DateForPmis.timeZoneSameAsLocale) {
            return dt;
        }
        return DayJsWrapper.fromTimeZoneToLocale(dt, DateForPmis._timeZoneId);
    }

    private _convertUtcToLocal(): Date {
        const dt = new Date(this);
        const utcNum = Date.UTC(
            dt.getFullYear(),
            dt.getMonth(),
            dt.getDate(),
            dt.getHours(),
            dt.getMinutes(),
            dt.getSeconds(),
            dt.getMilliseconds()
        );
        return new Date(utcNum);
    }

    toUTC(): DateForPmis {
        if (this._kind === 'UTC') return this;

        this.toLocal();
        const dt = new Date(
            this.getUTCFullYear(),
            this.getUTCMonth(),
            this.getUTCDate(),
            this.getUTCHours(),
            this.getUTCMinutes(),
            this.getUTCSeconds(),
            this.getUTCMilliseconds()
        );
        this.setTime(dt.getTime());
        this._kind = 'UTC';
        return this;
    }

    getMinutesOfDay(): number {
        return this.getHours() * 60 + this.getMinutes();
    }

    getISOString() {
        if (this._kind === 'Local') {
            return this.toISOString();
        }
        return new DateForPmis(this).toLocal().toISOString();
    }

    static Create(
        year: number,
        month: number,
        date: number,
        hour = 0,
        minute = 0,
        second = 0,
        ms = 0
    ): DateForPmis {
        const dt = new Date(year, month, date, hour, minute, second, ms);
        return new DateForPmis(dt);
    }
}

type DateTimeKind = 'Local' | 'System' | 'UTC';
